/*
  Skye extras: product tile image swipe + dots, and "Saved items" (likes).
  - Saved items live in this browser's localStorage and expire after SAVE_DAYS.
  - Tiles are enhanced automatically (theme product grid, home featured strip, featured products slider).
*/
(function () {
  if (window.SkyeExtras) return;

  var script = document.currentScript;
  var SAVE_DAYS = Number((script && script.dataset.days) || 30);
  var MAX_SAVED = 60;
  var MAX_IMAGES = 8;
  var KEY = 'skye-saved-v1';
  var DAY = 864e5;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  var TILE_SPECS = [
    { tile: '.product-item', media: '.product-item__image', skip: '.predictive-search__grid-item' },
    { tile: '.ai-collection-strip__card', media: '.ai-collection-strip__image-wrap' },
    { tile: '[class*="ai-featured-products-"][class$="__card"]', media: '[data-media]' }
  ];

  var HEART = '<svg class="skye-heart-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.3s-7.4-4.5-9.2-9.1C1.5 7.9 3.6 4.6 7 4.6c2 0 3.6 1.1 5 2.9 1.4-1.8 3-2.9 5-2.9 3.4 0 5.5 3.3 4.2 6.6-1.8 4.6-9.2 9.1-9.2 9.1z"/></svg>';
  var CLOSE = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var CHEV_L = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 18l-6-6 6-6"/></svg>';
  var CHEV_R = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 18l6-6-6-6"/></svg>';

  /* ---------------- helpers ---------------- */
  function handleFromUrl(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : null;
  }
  function sized(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    if (cents == null || isNaN(cents)) return '';
    var fmt = (window.theme && (theme.moneyFormat || theme.moneyWithoutCurrencyFormat)) || '£{{amount}}';
    var n = Number(cents) / 100;
    function withDelims(num, dec, th, de) {
      var p = num.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.join(de);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return withDelims(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(n, 0, '.', ',');
        default: return withDelims(n, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }

  /* ---------------- product data (cached) ---------------- */
  var pcache = {};
  function getProduct(h) {
    if (pcache[h]) return pcache[h];
    try {
      var ss = sessionStorage.getItem('skye-p:' + h);
      if (ss) return (pcache[h] = Promise.resolve(JSON.parse(ss)));
    } catch (e) {}
    pcache[h] = fetch(root + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('product ' + r.status); return r.json(); })
      .then(function (p) {
        var vs = p.variants || [];
        var v = vs.filter(function (x) { return x.available; })[0] || vs[0] || {};
        var slim = {
          h: p.handle, t: p.title, url: p.url,
          imgs: (p.images || []).slice(0, MAX_IMAGES),
          price: v.price != null ? v.price : p.price,
          cap: v.compare_at_price || null,
          vid: v.id || null, avail: !!p.available, multi: vs.length > 1
        };
        try { sessionStorage.setItem('skye-p:' + h, JSON.stringify(slim)); } catch (e) {}
        return slim;
      });
    pcache[h].catch(function () { delete pcache[h]; });
    return pcache[h];
  }

  /* ---------------- saved items store ---------------- */
  var memory = [];
  function load() {
    var list;
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = memory; }
    if (!Array.isArray(list)) list = [];
    var now = Date.now();
    var kept = list.filter(function (i) { return i && i.h && now - (i.ts || 0) < SAVE_DAYS * DAY; });
    if (kept.length !== list.length) save(kept, true);
    return kept;
  }
  function save(list, silent) {
    memory = list;
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    if (!silent) emit();
  }
  function isSaved(h) { return load().some(function (i) { return i.h === h; }); }
  function enrich(item, p) {
    item.t = p.t; item.url = p.url; item.img = p.imgs[0] || item.img || '';
    item.price = p.price; item.cap = p.cap; item.vid = p.vid; item.avail = p.avail; item.multi = p.multi;
  }
  function toggle(h) {
    var list = load();
    var idx = -1;
    list.forEach(function (x, i) { if (x.h === h) idx = i; });
    if (idx > -1) { list.splice(idx, 1); save(list); return false; }
    list.unshift({ h: h, ts: Date.now() });
    if (list.length > MAX_SAVED) list.length = MAX_SAVED;
    save(list);
    bumpHeader();
    getProduct(h).then(function (p) {
      var l = load();
      var it = l.filter(function (x) { return x.h === h; })[0];
      if (!it) return;
      enrich(it, p); save(l);
    }).catch(function () {});
    return true;
  }
  function emit() {
    var list = load();
    var set = {};
    list.forEach(function (i) { set[i.h] = true; });
    document.querySelectorAll('[data-skye-heart]').forEach(function (b) {
      var on = !!set[b.getAttribute('data-skye-heart')];
      b.classList.toggle('is-saved', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from saved items' : 'Save to saved items');
    });
    updateCounts(list);
    if (drawer && !drawer.hidden) renderDrawer();
  }
  function updateCounts(list) {
    list = list || load();
    document.querySelectorAll('[data-skye-saved-count]').forEach(function (c) {
      c.textContent = list.length > 99 ? '99+' : String(list.length);
      c.hidden = list.length === 0;
    });
  }
  window.addEventListener('storage', function (e) { if (e.key === KEY) emit(); });

  /* ---------------- hearts on tiles ---------------- */
  function makeHeart(h) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'skye-heart';
    b.setAttribute('data-skye-heart', h);
    b.innerHTML = HEART;
    var on0 = isSaved(h);
    b.classList.toggle('is-saved', on0);
    b.setAttribute('aria-pressed', on0 ? 'true' : 'false');
    b.setAttribute('aria-label', on0 ? 'Remove from saved items' : 'Save to saved items');
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var on = toggle(h);
      b.classList.remove('is-pop'); void b.offsetWidth; if (on) b.classList.add('is-pop');
    });
    return b;
  }
  function avoidQuickAdd(media, heart) {
    var qa = media.querySelector('.quick-add__button, .quick-add__holder button');
    if (!qa) return;
    var m = media.getBoundingClientRect(), q = qa.getBoundingClientRect();
    if (!q.width || !q.height) return;
    var overlapsCorner = q.right > m.right - 56 && q.bottom > m.bottom - 56;
    heart.style.bottom = overlapsCorner ? Math.round(m.bottom - q.top + 8) + 'px' : '';
  }

  /* ---------------- tile image gallery ---------------- */
  function buildGallery(media, link, p) {
    if (media.querySelector('.skye-gallery')) return;
    var imgs = p.imgs || [];
    if (imgs.length < 2) return;
    var existing = link.querySelector('img');
    var firstSrc = existing && (existing.currentSrc || existing.src);

    var g = document.createElement('div');
    g.className = 'skye-gallery';
    var track = document.createElement('a');
    track.className = 'skye-gallery__track';
    track.href = link.getAttribute('href');
    track.tabIndex = -1;
    track.setAttribute('aria-hidden', 'true');
    imgs.forEach(function (src, i) {
      var s = document.createElement('span');
      s.className = 'skye-gallery__slide';
      var im = document.createElement('img');
      im.alt = '';
      im.decoding = 'async';
      im.draggable = false;
      if (i === 0 && firstSrc) {
        im.src = firstSrc;
      } else {
        im.loading = 'lazy';
        im.src = sized(src, 720);
        im.srcset = [360, 540, 720, 960].map(function (w) { return sized(src, w) + ' ' + w + 'w'; }).join(', ');
        im.sizes = '(min-width: 990px) 25vw, (min-width: 750px) 33vw, 50vw';
      }
      s.appendChild(im);
      track.appendChild(s);
    });
    g.appendChild(track);

    var prev = document.createElement('button');
    prev.type = 'button'; prev.className = 'skye-gallery__nav skye-gallery__nav--prev'; prev.innerHTML = CHEV_L;
    prev.setAttribute('aria-label', 'Previous image'); prev.tabIndex = -1;
    var next = document.createElement('button');
    next.type = 'button'; next.className = 'skye-gallery__nav skye-gallery__nav--next'; next.innerHTML = CHEV_R;
    next.setAttribute('aria-label', 'Next image'); next.tabIndex = -1;
    g.appendChild(prev); g.appendChild(next);

    var n = imgs.length;
    var dots = document.createElement('div');
    dots.className = 'skye-dots';
    dots.setAttribute('aria-hidden', 'true');
    var inner = document.createElement('div');
    inner.className = 'skye-dots__inner';
    for (var i = 0; i < n; i++) { var d = document.createElement('span'); d.className = 'skye-dots__dot'; inner.appendChild(d); }
    dots.appendChild(inner);
    var STEP = 11, VISIBLE = 3;
    dots.style.width = (Math.min(n, VISIBLE) * STEP - 5) + 'px';

    link.insertAdjacentElement('afterend', g);
    media.appendChild(dots);

    var current = -1;
    function setActive(idx) {
      if (idx === current) return;
      current = idx;
      var start = Math.max(0, Math.min(idx - 1, n - VISIBLE));
      inner.style.transform = 'translateX(' + (-start * STEP) + 'px)';
      Array.prototype.forEach.call(inner.children, function (dot, k) {
        dot.classList.toggle('is-active', k === idx);
        var edge = (k === start && start > 0) || (k === start + VISIBLE - 1 && start + VISIBLE < n);
        dot.classList.toggle('is-small', edge && k !== idx);
      });
      prev.disabled = idx === 0;
      next.disabled = idx === n - 1;
    }
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var w = track.clientWidth || 1;
        setActive(Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / w))));
      });
    }, { passive: true });
    function go(dir, e) {
      e.preventDefault(); e.stopPropagation();
      track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
    }
    prev.addEventListener('click', function (e) { go(-1, e); });
    next.addEventListener('click', function (e) { go(1, e); });
    // stop desktop drag-click from opening the product after a mouse drag
    var downX = 0;
    track.addEventListener('pointerdown', function (e) { downX = e.clientX; });
    track.addEventListener('click', function (e) { if (Math.abs(e.clientX - downX) > 8) e.preventDefault(); });
    setActive(0);
    media.classList.add('skye-has-gallery');
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      var media = en.target, h = media.getAttribute('data-skye-media');
      var link = media.querySelector(':scope > a[href*="/products/"]') || media.querySelector('a[href*="/products/"]');
      if (!h || !link) return;
      getProduct(h).then(function (p) { buildGallery(media, link, p); }).catch(function () {});
    });
  }, { rootMargin: '300px 0px' }) : null;

  function enhanceTile(tile, spec) {
    if (tile.hasAttribute('data-skye-done')) return;
    if (spec.skip && tile.matches(spec.skip)) return;
    var media = tile.querySelector(spec.media);
    if (!media) return;
    var link = tile.querySelector('a[href*="/products/"]');
    var h = link && handleFromUrl(link.getAttribute('href'));
    if (!h) return;
    tile.setAttribute('data-skye-done', '');
    if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
    media.setAttribute('data-skye-media', h);
    var heart = makeHeart(h);
    media.appendChild(heart);
    requestAnimationFrame(function () { avoidQuickAdd(media, heart); });
    media.addEventListener('mouseenter', function () { setTimeout(function () { avoidQuickAdd(media, heart); }, 250); });
    if (io) io.observe(media);
  }

  function scan(rootEl) {
    var scope = rootEl && rootEl.querySelectorAll ? rootEl : document;
    TILE_SPECS.forEach(function (spec) {
      scope.querySelectorAll(spec.tile).forEach(function (t) { enhanceTile(t, spec); });
    });
  }
  function isOurs(node) {
    if (!node || node.nodeType !== 1) return true;
    if (drawer && drawer.contains(node)) return true;
    var c = typeof node.className === 'string' ? node.className : '';
    return c.indexOf('skye-') === 0 || node.hasAttribute('data-skye-saved-wrap');
  }

  /* ---------------- header button ---------------- */
  function injectHeader() {
    document.querySelectorAll('.header-sections [data-cart-toggle]').forEach(function (cart) {
      var wrap = cart.parentElement;
      if (!wrap || !wrap.parentElement) return;
      var prevEl = wrap.previousElementSibling;
      if (prevEl && prevEl.hasAttribute('data-skye-saved-wrap')) return;
      var w = document.createElement('div');
      w.className = wrap.className;
      w.setAttribute('data-skye-saved-wrap', '');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'navlink skye-saved-toggle';
      b.setAttribute('aria-label', 'Saved items');
      b.setAttribute('title', 'Saved items');
      b.setAttribute('aria-haspopup', 'dialog');
      b.innerHTML = HEART + '<span class="skye-saved-count" data-skye-saved-count hidden>0</span>';
      b.addEventListener('click', function (e) { e.preventDefault(); openDrawer(b); });
      w.appendChild(b);
      wrap.insertAdjacentElement('beforebegin', w);
    });
  }
  function bumpHeader() {
    document.querySelectorAll('.skye-saved-toggle').forEach(function (b) {
      b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump');
    });
  }

  /* ---------------- saved drawer ---------------- */
  var drawer = null, lastFocus = null;
  function buildDrawer() {
    drawer = document.createElement('div');
    drawer.className = 'skye-saved';
    drawer.hidden = true;
    drawer.innerHTML =
      '<div class="skye-saved__underlay" data-skye-close></div>' +
      '<aside class="skye-saved__panel" role="dialog" aria-modal="true" aria-labelledby="skye-saved-title" tabindex="-1">' +
        '<div class="skye-saved__head">' +
          '<h2 class="skye-saved__title" id="skye-saved-title">Saved items</h2>' +
          '<button type="button" class="skye-saved__close" data-skye-close aria-label="Close saved items">' + CLOSE + '</button>' +
        '</div>' +
        '<div class="skye-saved__body" data-skye-list></div>' +
        '<p class="skye-saved__note">Saved on this device for ' + SAVE_DAYS + ' days.</p>' +
      '</aside>';
    document.body.appendChild(drawer);
    drawer.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-skye-close]')) { closeDrawer(); return; }
      var rm = t.closest('[data-skye-remove]');
      if (rm) { toggle(rm.getAttribute('data-skye-remove')); return; }
      var add = t.closest('[data-skye-add]');
      if (add) addToBasket(add);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && !drawer.hidden) closeDrawer();
    });
  }
  function openDrawer(opener) {
    if (!drawer) buildDrawer();
    lastFocus = opener || document.activeElement;
    renderDrawer();
    drawer.hidden = false;
    document.documentElement.classList.add('skye-saved-open');
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      drawer.querySelector('.skye-saved__panel').focus();
    });
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('skye-saved-open');
    setTimeout(function () { drawer.hidden = true; }, 250);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function renderDrawer() {
    var list = load();
    var box = drawer.querySelector('[data-skye-list]');
    if (!list.length) {
      box.innerHTML = '<div class="skye-saved__empty">' + HEART + '<p>Nothing saved yet.</p><p>Tap the heart on any product to save it here.</p></div>';
      return;
    }
    box.innerHTML = list.map(function (i) {
      var url = i.url || (root + 'products/' + encodeURIComponent(i.h));
      var title = i.t || '';
      var img = i.img ? '<img src="' + esc(sized(i.img, 240)) + '" alt="" loading="lazy">' : '';
      var price = i.price != null
        ? '<span class="skye-saved__price">' + esc(money(i.price)) + (i.cap && i.cap > i.price ? ' <s>' + esc(money(i.cap)) + '</s>' : '') + '</span>'
        : '';
      var action;
      if (!i.t) action = '';
      else if (!i.avail) action = '<span class="skye-saved__soldout">Sold out</span>';
      else if (i.multi) action = '<a class="skye-saved__btn" href="' + esc(url) + '">Choose options</a>';
      else action = '<button type="button" class="skye-saved__btn" data-skye-add="' + esc(i.vid) + '">Add to basket</button>';
      return '<div class="skye-saved__item">' +
        '<a class="skye-saved__thumb" href="' + esc(url) + '">' + img + '</a>' +
        '<div class="skye-saved__info">' +
          '<a class="skye-saved__name" href="' + esc(url) + '">' + (esc(title) || '<span class="skye-saved__loading">Loading…</span>') + '</a>' +
          price +
          '<div class="skye-saved__actions">' + action + '</div>' +
        '</div>' +
        '<button type="button" class="skye-saved__remove" data-skye-remove="' + esc(i.h) + '" aria-label="Remove ' + esc(title || 'item') + '">' + CLOSE + '</button>' +
      '</div>';
    }).join('');
    // fill in any items saved before their details loaded (or older entries)
    list.forEach(function (i) {
      if (i.t) return;
      getProduct(i.h).then(function (p) {
        var l = load(); var it = l.filter(function (x) { return x.h === i.h; })[0];
        if (it) { enrich(it, p); save(l); }
      }).catch(function () {
        var l = load().filter(function (x) { return x.h !== i.h; }); // product no longer exists
        save(l);
      });
    });
  }
  function addToBasket(btn) {
    var id = Number(btn.getAttribute('data-skye-add'));
    if (!id) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add');
      btn.textContent = 'Added ✓';
      refreshCart();
      setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2000);
    }).catch(function () {
      btn.textContent = 'Try again';
      btn.disabled = false;
    });
  }
  function refreshCart() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var n = cart.item_count;
      document.querySelectorAll('cart-count').forEach(function (el) {
        el.setAttribute('data-cart-count', n);
        el.textContent = (n > 9 && !el.classList.contains('cart__items-count')) ? '9+' : String(n);
      });
      var cd = document.querySelector('cart-drawer');
      if (cd) cd.classList.toggle('is-empty', n === 0);
      var wrap = document.querySelector('[data-section-type="cart-drawer"]');
      var sid = wrap && wrap.dataset.sectionId;
      if (!sid) return;
      return fetch(root + '?sections=' + encodeURIComponent(sid)).then(function (r) { return r.json(); }).then(function (data) {
        if (!data || !data[sid]) return;
        var doc = new DOMParser().parseFromString(data[sid], 'text/html');
        ['cart-items', '[data-cart-total]'].forEach(function (sel) {
          var fresh = doc.querySelector(sel), current = wrap.querySelector(sel);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        });
      });
    }).catch(function () {}).then(function () {
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    });
  }

  /* ---------------- init ---------------- */
  function init() {
    injectHeader();
    scan(document);
    emit();
    var pending = false;
    var mo = new MutationObserver(function (muts) {
      if (pending) return;
      var relevant = muts.some(function (m) {
        if (drawer && drawer.contains(m.target)) return false;
        return Array.prototype.some.call(m.addedNodes || [], function (n) { return !isOurs(n); });
      });
      if (!relevant) return;
      pending = true;
      setTimeout(function () { pending = false; injectHeader(); scan(document); updateCounts(); }, 150);
    });
    mo.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', function () { injectHeader(); scan(document); updateCounts(); });
    window.addEventListener('resize', function () {
      document.querySelectorAll('[data-skye-media]').forEach(function (m) {
        var h = m.querySelector('.skye-heart'); if (h) avoidQuickAdd(m, h);
      });
    });
  }

  window.SkyeExtras = { open: function () { openDrawer(); }, toggle: toggle, isSaved: isSaved, list: load };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
